
const digest = '81c4cdb281a71740128e9eaad32e4f5f7dbc0231baafcc0586299ca417120d0c';
const classes = {"collapseContent":"_collapseContent_kegot_1","row":"_row_kegot_10","item":"_item_kegot_15","name":"_name_kegot_20","wrapper":"_wrapper_kegot_24"};
const css = `._collapseContent_kegot_1 {
  font-size: 14px;
  padding: 12px;
  background: #ffffff;
}
._collapseContent_kegot_1 span {
  font-weight: 500;
}

._row_kegot_10 {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}
._row_kegot_10 ._item_kegot_15 {
  font-size: 14px;
  display: flex;
  flex-direction: column;
}
._row_kegot_10 ._item_kegot_15 ._name_kegot_20 {
  color: #9ea0a5;
}

._wrapper_kegot_24 {
  padding: 12px;
  border-left: 0;
  border-bottom: 1px solid #eaedf3;
}
._wrapper_kegot_24:first-child {
  border-top: 1px solid #eaedf3;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  